<template>
    <Dialog
        v-if="!showCreateTask && editTask === null"
        :is-popup="isOpen"
        @close="close"
        :scrollable="true"
    >
        <div
            class="activity-detail-popup"
            :class="['activity-detail-popup--'+item.type]"
             v-if="item">
            <div class="row centered">
                <div class="label">{{labels[item.type]}}</div>
                <div class="date">
                    <span class="time">{{ item.datetime | timestampTime(true) }}</span>
                    {{ item.datetime | timestampFullDate(false, true) }}
                </div>
            </div>
            <div
                v-if="item.type === 'meeting'"
                class="row centered"
            >
                <div
                    class="pair-avatar"
                    :style="item.initiatorAvatar ? { backgroundImage: `url(${item.initiatorAvatar})`} : {}"
                ></div>
                <div class="pair-name">
                    {{ pairFullName }}
                </div>
            </div>
            <div class="row theme">
                {{ item.theme }}
            </div>
            <div class="row description description-html html-block" v-html="item.description"></div>

            <div class="row" v-if="item.link">
                <a
                    class="link"
                    :href="item.link"
                >
                    Перейти по ссылке
                </a>
            </div>
            <div class="row cols">
                <div
                    class="info-item"
                    v-if="item.location"
                >
                    <div class="tag">Место:</div>
                    <div class="text">{{ item.location }}</div>
                    <div class="action-btn" @click="openMap">
                        <font-awesome-icon icon="map-marker-alt" />
                        Показать на карте
                    </div>
                </div>
                <div
                    class="info-item"
                    v-if="showStatusPicker && !canSelectStatus"
                >
                    <div class="text" v-if="isCompleted">Вы посетили данное мероприятие</div>
                    <div class="text" v-if="isMissed">Вы пропустили данное мероприятие</div>
                    <div
                        class="action-btn"
                        @click="changingStatus = true"
                    >
                        Изменить решение
                    </div>
                </div>
            </div>
            <div
                class="row cols"
                v-if="canSelectStatus"
            >
                <Button
                    class="btn btn--missed"
                    @click="setMissedStatus"
                    :class="{ loading }"
                >Пропустил(-а)</Button>
                <Button
                    class="btn btn--complete"
                    @click="setCompletedStatus"
                    :class="{ loading }"
                >Посетил(-а)</Button>
            </div>
            <MeetingRating
                v-if="showRatingPicker"
                :meeting-id="item.id"
                :rating="item.rating"
                @update="syncActivity"
            ></MeetingRating>
            <div class="tasks" v-if="hasTasks">
                <h2 class="title">Добавленные задачи</h2>
                <div class="tasks__add-btn" @click="showCreateTask = true">Создать задачу</div>
                <TaskList
                    :items="meetingTasks(item.id)"
                    @click="edit"
                />
            </div>
        </div>
    </Dialog>
    <TaskUpdate
        v-else-if="editTask !== null"
        v-model="editTask"
    ></TaskUpdate>
    <TaskCreate
        v-else
        v-model="showCreateTask"
        :meeting-id="item.id"
    ></TaskCreate>
</template>

<script>
import Dialog from '../../../../UI/Dialog';
import Button from '../../../../UI/Button';
import TaskList from '../tasks/List';
import TaskCreate from '../tasks/Create';
import TaskUpdate from '../tasks/Update';
import MeetingRating from './MeetingRating';
import {mapActions, mapGetters, mapState} from 'vuex';
import {ActivityStatus, ActivityType} from '@/stores/mentoring/activities';

export default {
    name: 'ActivityDetail',
    props: {
        activityType: {
            type: String,
            required: false,
        },
        activityId: {
            type: Number,
            required: false,
        },
    },
    data: () => ({
        labels: {
            webinar: 'Вебинар',
            session: 'Сессия',
            course: 'Курс',
            meeting: 'Встреча',
        },
        showCreateTask: false,
        editTask: null,
        changingStatus: false,
        item: null,
        loading: false,
    }),
    components: {
        Dialog,
        Button,
        TaskList,
        TaskCreate,
        TaskUpdate,
        MeetingRating,
    },
    watch: {
        activityType() {
            this.syncActivity();
        },
        activityId() {
            this.syncActivity();
        },
    },
    mounted() {
        this.syncActivity();
    },
    computed: {
        ...mapState('mentoring', [
            'role',
            'pair',
        ]),
        ...mapGetters('mentoring/tasks', [
            'meetingTasks',
        ]),
        ...mapGetters('mentoring/activities', [
            'getActivity',
        ]),
        getRoleName() {
            return this.role === 'mentor' ? 'Наставляемый' : 'Наставник';
        },
        pairFullName() {
            if (!this.pair) return '';
            return `${this.pair.surname} ${this.pair.name}`;
        },
        isOpen: {
            get() {
                return this.item !== null;
            },
            set() {
                this.close();
            },
        },
        hasTasks() {
            return this.item.type === ActivityType.meeting && this.item.status === ActivityStatus.completed;
        },
        showStatusPicker() {
            return this.item.datetime < new Date() && this.role === 'student' && this.item.type !== ActivityType.meeting ;
        },
        showRatingPicker() {
            return this.item.datetime < new Date() && this.item.type === ActivityType.meeting ;
        },
        canSelectStatus() {
            return this.changingStatus || (this.showStatusPicker && this.item.status === ActivityStatus.in_progress);
        },
        isCompleted() {
            return this.item && this.item.status === ActivityStatus.completed;
        },
        isMissed() {
            return this.item && this.item.status === ActivityStatus.missed;
        },
    },
    methods: {
        ...mapActions('mentoring/activities', [
            'updateActivityStatus',
        ]),
        close() {
            this.$emit('close');
        },
        openMap() {
            window.open('https://yandex.com/maps/?text='+this.item.location, '__blank');
        },
        edit(i) {
            this.editTask = this.meetingTasks(this.item.id)[i];
        },
        async setCompletedStatus() {
            this.loading = true;
            this.item = await this.updateActivityStatus({item: this.item, status: ActivityStatus.completed});
            this.changingStatus = false;
            this.loading = false;
        },
        async setMissedStatus(status) {
            this.loading = true;
            this.item = await this.updateActivityStatus({item: this.item, status: ActivityStatus.missed});
            this.changingStatus = false;
            this.loading = false;
        },
        syncActivity() {
            this.item = this.getActivity({ id: this.activityId, type: this.activityType });
            this.changingStatus = false;
        },
    },
};
</script>

<style lang="scss">
    @import '../../../../../styles/rem';

    .activity-detail-popup {
        width: rem(538);

        @include on-mobile {
            width: 100%
        }

        $icons:
            "webinar" #51BA20 rgba(81, 186, 32, 0.3),
            "session" #783AFC rgba(120, 58, 252, 0.3),
            "course" #FC923A rgba(252, 146, 58, 0.3),
            "meeting" #3AA0FD rgba(58, 160, 253, 0.3);

        @each $type, $color, $color2 in $icons {
            &--#{$type} {
                .label,
                .time,
                .date,
                .action-btn,
                .show-details {
                    color: $color;
                }
                .action-btn {
                    border-color: $color;
                }
                .label,
                .show-details {
                    background-color: $color2;
                }
            }
        }

        .row {
            display: flex;
            flex-direction: row;
            width: 100%;
            margin-bottom: rem(16);
            align-items: flex-end;

            @include on-mobile {
                flex-wrap: wrap;
                margin-bottom: mrem(16);
            }

            &.centered {
                align-items: center;
            }

            &.cols {
                justify-content: space-between;
            }
        }

        .label {
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            padding: rem(6) rem(12);
            display: inline-block;
            border-radius: rem(32);
            margin-right: rem(8);

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
                padding: rem(6) mrem(12);
                border-radius: mrem(32);
                margin-right: mrem(8);
            }
        }

        .pair-avatar {
            height: rem(32);
            width: rem(32);
            border-radius: rem(32);
            background-image: url("../../../../../assets/images/avatar_placeholder.png");
            background-size: contain;
            background-repeat: no-repeat;
            margin-right: rem(16);

            @include on-mobile {
                height: mrem(32);
                width: mrem(32);
                border-radius: mrem(32);
                margin-right: mrem(16);
            }
        }

        .pair-name {
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            color: #3AA0FD;

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
            }
        }

        .time {
            margin-right: rem(8);

            @include on-mobile {
                margin-right: mrem(8);
            }
        }

        .date {
            width: 100%;
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);

            @include on-mobile {
                width: auto;
                font-size: mrem(14);
                line-height: mrem(20);
            }
        }

        .theme {
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #000000;

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
            }
        }

        .description {
            font-size: rem(16);
            line-height: rem(24);
            color: #000000;

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
            }
        }

        .info-item {
            width: 48%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            @include on-mobile {
                width: 100%;
            }

            .tag {
                font-size: rem(14);
                height: rem(20);
                line-height: rem(20);
                color: #8F9398;
                margin-bottom: rem(4);

                @include on-mobile {
                    font-size: mrem(14);
                    height: mrem(20);
                    line-height: mrem(20);
                    margin-bottom: mrem(4);
                }
            }

            .text {
                height: rem(14);
                font-size: rem(14);
                line-height: rem(20);
                color: #000000;
                margin-bottom: rem(16);

                @include on-mobile {
                    height: mrem(14);
                    font-size: mrem(14);
                    line-height: mrem(20);
                    margin-bottom: mrem(16);
                }
            }

            .action-btn {
                display: block;
                border-width: 1px;
                border-style: solid;
                padding: rem(6) rem(13);
                font-weight: 600;
                font-size: rem(12);
                height: rem(32);
                border-radius: rem(32);
                line-height: rem(18);
                cursor: pointer;
                user-select: none;
                text-align: center;
                width: 100%;

                @include on-mobile {
                    padding: mrem(6) mrem(13);
                    font-size: mrem(12);
                    height: mrem(32);
                    border-radius: mrem(32);
                    line-height: mrem(18);
                }
            }
        }

        .link {
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            color: #4663AB;
            padding: 1px;
            border-bottom: 1px solid #4663AB;

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
            }
        }

        .btn {
            width: 48%;
            border-radius: rem(4);

            @include on-mobile {
                border-radius: mrem(4);
                width: 100%;
                margin-bottom: mrem(16);
            }

            &--missed {
                background: #D1004A;
            }

            &--complete {
                background: #4663AB;
            }

            &.loading {
                cursor: wait;
            }
        }

        .tasks {
            background: #F2F2F2;
            padding: rem(16);

            @include on-mobile {
                padding: mrem(16);
            }

            .title {
                font-weight: 600;
                font-size: rem(16);
                line-height: rem(24);
                color: #2A2626;
                padding-bottom: rem(11);

                @include on-mobile {
                    font-size: mrem(16);
                    line-height: mrem(24);
                    padding-bottom: mrem(11);
                }
            }

            &__add-btn {
                background: #1184ED;
                backdrop-filter: blur(rem(27.1828));
                border-radius: rem(32);
                font-weight: 600;
                font-size: rem(14);
                line-height: rem(20);
                color: #FFFFFF;
                width: 100%;
                padding: rem(6);
                text-align: center;
                user-select: none;
                cursor: pointer;

                @include on-mobile {
                    backdrop-filter: blur(mrem(27.1828));
                    border-radius: mrem(32);
                    font-size: mrem(14);
                    line-height: mrem(20);
                    padding: mrem(6);
                    margin-bottom: mrem(16);
                }
            }
        }
    }

    .description-html {
        p:first-child {
            margin-top: 0;
        }
        p:last-child {
            margin-bottom: 0;
        }
    }
</style>

<style lang="scss" scoped>

</style>